import { Flex } from '@aloft/toolkit-sui';

import { useEffect } from 'react';

import { useTkv2ReferenceBarEvents } from '../../components/ReferenceBar/useTkv2ReferenceBarEvents.ts';
import {
  setReferenceViewOpen,
  setSelectedDataSheet,
} from '../../redux/features/referenceBarUISlice.ts';
import { useAppDispatch } from '../../redux/hooks.ts';
import { OrderDetails } from './ModuleComponents/OrderDetails.tsx';
import { SubjectPropertyDetails } from './ModuleComponents/SubjectPropertyDetails.tsx';

export const OrderDetailsModule = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSelectedDataSheet('client-information'));
    dispatch(setReferenceViewOpen(true));
  }, []);

  return (
    <Flex {...useTkv2ReferenceBarEvents()} width="100%" gap={2}>
      <Flex flexDirection="column" width="100%" gap={2} backgroundColor="surface1" margin="15px">
        <OrderDetails />
        <SubjectPropertyDetails />
      </Flex>
    </Flex>
  );
};
